import {compact, flattenDeep, get, uniq} from 'lodash'

export default {
  methods: {
    findEmails (str) {
      const arr = str.split(', ')
      // eslint-disable-next-line max-len,no-useless-escape
      const regex = /(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/gmi
      const emails = arr.map(email => email.match(regex))
      const flatten = compact(uniq(flattenDeep(emails)))
      const userEmail = get(this.activeUser, 'gmail.email', '')
      return flatten.filter(email => email !== userEmail)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/findEmails.js